// extracted by css-extract-rspack-plugin
export default {"container":"dzj3Y","front":"coR4A","back":"Hrpth","hideUnder":"gJKFU","visible":"QiqMk","static":"bkuH8","covered":"JmSP9","tablet":"VXt1x","mobile":"VcoyI"};